import { Link, useParams } from "react-router-dom";
import Footer from "../Footer";
import Header from "../Header";
import { useState, useEffect, useContext, useCallback } from "react";
import { ThemeContext } from "../../../Contaxt/ThemeContext";
import axiosIns, { API_URL } from "../../../config";
import "../../../ComponentsCss/ServiceDetailPage.css";
import Faqs from "../Faqs";
import { decryptData } from "../../../_services";

const buildIndustryLayout = (items) => {
    const topRow = items.slice(0, 4);
    const bottomRow = items.slice(4, 8);
    const middleSource = items.slice(8, 14);

    return {
        topRow,
        leftItem: middleSource[0],
        centerItems: middleSource.slice(2, 6),
        rightItem: middleSource[1] || null,
        bottomRow,
    };
};

const IndustryCard = ({ item }) => (
    <div className="service_industries_box">
        <img src={item.icon} alt="" />
        <p className="mb-0">{item.serviceSectorName}</p>
    </div>
);

const hasContent = (value) => typeof value === "string" && value.trim().length > 0;

const getCustomSectionValue = (section, fieldName) => {
    const field = section?.fields?.find((item) => item?.name === fieldName);
    return typeof field?.value === "string" ? field.value.trim() : "";
};

const ServiceHtmlSection = ({ section }) => {
    if (!section || (!hasContent(section.title) && !hasContent(section.html))) {
        return null;
    }

    return (
        <div className="service_detail_section service_html_section">
            {hasContent(section.title) && <p className="exciting-ER4 m-0">{section.title}</p>}
            {hasContent(section.html) && (
                <div
                    className="service_detail_html portfolio-our-agency"
                    dangerouslySetInnerHTML={{ __html: section.html }}
                />
            )}
        </div>
    );
};

const CustomSections = ({ sections }) => {
    const items = Array.isArray(sections)
        ? sections
            .map((section) => ({
                title: getCustomSectionValue(section, "title"),
                subtitle: getCustomSectionValue(section, "subtitle"),
                description: getCustomSectionValue(section, "description"),
            }))
            .filter((section) => hasContent(section.title) || hasContent(section.subtitle) || hasContent(section.description))
        : [];

    if (items.length === 0) {
        return null;
    }

    return (
        <>
            {items.map((section, index) => {
                const isContentFirst = index % 2 === 0;
                const titleColumn = (
                    <div className="fw-col-xs-12 fw-col-sm-6 fw-col-md-4 mb-3 service_custom_section_title">
                        {hasContent(section.title) && <p className="exciting-ER4 m-0" style={{ lineHeight: "normal" }}>{section.title}</p>}
                    </div>
                );
                const contentColumn = (
                    <div className="fw-col-xs-12 fw-col-sm-6 fw-col-md-8 service_custom_section_content">
                        {hasContent(section.subtitle) && <p className="portfolio-our-agencys" style={{ fontSize: "16px", lineHeight: "25px" }}>{section.subtitle}</p>}
                        {hasContent(section.description) && <p className="portfolio-our-agency" style={{ fontSize: "16px" }}>{section.description}</p>}
                    </div>
                );

                return (
                    <div className="service_detail_section service_custom_section" key={index}>
                        <div className={`fw-row service_custom_section_row ${isContentFirst ? "content_first" : "title_first"}`}>
                            {isContentFirst ? contentColumn : titleColumn}
                            {isContentFirst ? titleColumn : contentColumn}
                        </div>
                    </div>
                );
            })}
        </>
    );
};

const AIAnswerBox = ({ box }) => {
    const items = Array.isArray(box?.data) ? box.data : [];

    if (!hasContent(box?.title) && items.length === 0) {
        return null;
    }

    return (
        <div className="service_detail_section service_ai_answer_box">
            <p className="exciting-ER4 m-0">{box?.title || "AI Answer Box"}</p>
            <div className="service_ai_answer_list">
                {items.map((item, index) => (
                    <div className="service_ai_answer_item" key={index}>
                        {hasContent(item?.q) && <p className="portfolio-our-agencys">{item.q}</p>}
                        {hasContent(item?.answer) && <p className="portfolio-our-agency mb-0">{item.answer}</p>}
                    </div>
                ))}
            </div>
        </div>
    );
};

const DEFAULT_QUICK_FACT_COLOR = "#2f7df6";

const getQuickFactColor = (color) => {
    return hasContent(color) ? color : DEFAULT_QUICK_FACT_COLOR;
};

const ReactServiceIcon = () => (
    <svg viewBox="0 0 64 64" aria-hidden="true" focusable="false">
        <circle cx="32" cy="32" r="5.5" fill="currentColor" />
        <ellipse cx="32" cy="32" rx="24" ry="9.5" fill="none" stroke="currentColor" strokeWidth="4" />
        <ellipse cx="32" cy="32" rx="24" ry="9.5" fill="none" stroke="currentColor" strokeWidth="4" transform="rotate(60 32 32)" />
        <ellipse cx="32" cy="32" rx="24" ry="9.5" fill="none" stroke="currentColor" strokeWidth="4" transform="rotate(120 32 32)" />
    </svg>
);

const QuickFacts = ({ facts }) => {
    const items = Array.isArray(facts?.data) ? facts.data : [];

    if (!hasContent(facts?.title) && items.length === 0) {
        return null;
    }

    return (
        <div className="service_detail_section service_quick_facts_section">
            <div className="service_quick_facts_header">
                <p className="exciting-ER4 m-0">{facts?.title || "Quick Facts"}</p>
                <p className="service_quick_facts_subtitle">Everything you need to know about our services</p>
            </div>
            <div className="service_quick_facts">
                {items.map((item, index) => {
                    const color = getQuickFactColor(item?.color);

                    return (
                        <div className="service_quick_fact" style={{ "--quick-fact-color": color }} key={index}>
                            <div className="service_quick_fact_icon">
                                {hasContent(item?.image) ? (
                                    <img src={item.image} alt="" />
                                ) : (
                                    <ReactServiceIcon />
                                )}
                            </div>
                            <div className="service_quick_fact_content">
                                <p className="service_quick_fact_label">{item?.feature}</p>
                                <p className="service_quick_fact_value">{item?.details}</p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const DevelopmentProcess = ({ process }) => {
    if (!process || (!hasContent(process.title) && !hasContent(process.image))) {
        return null;
    }

    return (
        <div className="service_detail_section service_development_process_section">
            {hasContent(process.title) && <p className="exciting-ER4 m-0">{process.title}</p>}
            {hasContent(process.image) && (
                <div className="service_process_image">
                    <img src={process.image} alt={process.title || "Development process"} className="img-fluid w-100" />
                </div>
            )}
        </div>
    );
};

const CaseStudies = ({ caseStudies }) => {
    const items = Array.isArray(caseStudies?.data) ? caseStudies.data : [];

    if (!hasContent(caseStudies?.title) && items.length === 0) {
        return null;
    }

    return (
        <div className="service_detail_section service_case_studies_section">
            <p className="exciting-ER4 m-0">{caseStudies?.title || "Case Studies"}</p>
            <div className="service_case_studies">
                {items.map((item, index) => (
                    <a className="service_case_study" href={item?.link} rel="noreferrer" key={index}>
                        <span>{item?.name || "View Case Study"}</span>
                    </a>
                ))}
            </div>
        </div>
    );
};

const FactsFeatures = ({ section }) => {
    const items = Array.isArray(section?.data) ? section.data : [];

    if (!hasContent(section?.title) && items.length === 0) {
        return null;
    }

    return (
        <div className="service_detail_section service_facts_features_section">
            <p className="exciting-ER4 m-0">{section?.title || "Facts Features"}</p>
            <div className="service_facts_features">
                {items.map((item, index) => (
                    <div className="service_facts_feature" key={index}>
                        <span className="service_facts_feature_count">{String(index + 1).padStart(2, "0")}</span>
                        <div>
                            {hasContent(item?.title) && <p className="service_facts_feature_title">{item.title}</p>}
                            {hasContent(item?.details) && <p className="service_facts_feature_details">{item.details}</p>}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const SERVICE_CONTACT_EMAIL = "business@ishivax.com";
const SERVICE_CONTACT_PHONE_DISPLAY = "+91 98291 97777";
const SERVICE_CONTACT_PHONE_HREF = "tel:+919829197777";

const ServiceDetailCta = () => (
    <div className="service_detail_section service_detail_cta">
        <div className="service_detail_cta_actions">
            <a className="service_detail_cta_btn call" href={SERVICE_CONTACT_PHONE_HREF} aria-label={`Call iShivax at ${SERVICE_CONTACT_PHONE_DISPLAY}`}>
                <span className="service_detail_cta_icon fa fa-phone" aria-hidden="true"></span>
                <span>
                    <b>Call Now</b>
                </span>
            </a>
            <a className="service_detail_cta_btn email" href={`mailto:${SERVICE_CONTACT_EMAIL}`} aria-label={`Email iShivax at ${SERVICE_CONTACT_EMAIL}`}>
                <span className="service_detail_cta_icon fa fa-envelope" aria-hidden="true"></span>
                <span>
                    <b>Email Team</b>
                </span>
            </a>
        </div>
    </div>
);

const ServicesDetails = () => {
    const params = useParams();
    const serviceSlug = params?.slug;
    const { isLight } = useContext(ThemeContext);
    const [data, setData] = useState();
    const [industryData, seIndustryData] = useState();

    const fetchData = useCallback(async () => {
        try {
            const response = await axiosIns.get(`${API_URL.GetServiceDetailByServiceSlug}?slug=${serviceSlug}`);

            if (response.data.isSuccess === 1) {
                setData(response.data.data);
            } else if (response.data.isSuccess === 0) {
                setData(null);
            }
        } catch (error) {
            setData(null);
        }
    }, [serviceSlug]);

    const fetchIndustryData = useCallback(async () => {
        try {
            const response = await axiosIns.get(`${API_URL.GetServiceIndustryByServiceSlug}?slug=${serviceSlug}`);

            const encrypted = response?.data?.encryptedData;

            if (!encrypted) {
                seIndustryData([]);
                return;
            }

            const decrypted = decryptData(encrypted);

            if (decrypted && decrypted.isSuccess === 1 && Array.isArray(decrypted.data)) {
                seIndustryData(decrypted?.data);
            } else {
                seIndustryData([]);
            }
        } catch (error) {
            seIndustryData(null);
        }
    }, [serviceSlug]);

    useEffect(() => {
        fetchData();
        fetchIndustryData();
    }, [fetchData, fetchIndustryData]);

    const industries = industryData || [];
    const { topRow, leftItem, centerItems, rightItem, bottomRow } = buildIndustryLayout(industries);

    return (
        <div>
            <Header />
            <div className="services_details_main">
                <section>
                    <div className={`fw-main-row ${isLight ? "black-bg-content-LIGHT" : "black-bg-content"}`}>
                        <div className="fw-full-container-top pb-5" style={{ backgroundImage: "url(./images/bg-dots.png)", overflow: "hidden" }}>
                            <div className="fw-container">
                                <div className="fw-row">
                                    <div className="fw-col-xs-12 ">
                                        <div className="fw-divider-space"></div>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-between align-items-center banner-seo-media-images">
                                    <div className="seo-media-images-common">
                                        <img className="top-image-arrow-1" src="/images/Vector-line-straight.png" alt="" />
                                        <img className="top-image-arrow-2" src="/images/Vector-line-straight.png" alt="" />
                                    </div>

                                    <div className="seo-media-images-common">
                                        <img className="top-image-arrow-3" src="/images/Vector-line-straight.png" alt="" />
                                        <img className="top-image-arrow-4" src="/images/Vector-line-straight.png" alt="" />
                                    </div>
                                </div>
                                <div className="content-under-image">
                                    <div className="top-vector_main">
                                        <img className="vector-line-common" src="/images/Vector-upper-arrow.png" alt="" />
                                        <div className="fw-row">
                                            <div className="cector-cross-line-allign">
                                                <div className="vector-class-common">
                                                    <div className="dots-first">
                                                        <div className="dot-common"></div>
                                                        <div className="dot-common"></div>
                                                    </div>
                                                    <img className="vector-cross-common" src="/images/vector.png" alt="" />
                                                    <div className="dots-second">
                                                        <div className="dot-common"></div>
                                                        <div className="dot-common"></div>
                                                    </div>
                                                </div>
                                                <div className="fw-heading fw-heading-h2 d-flex justify-content-center align-items-center">
                                                    <h2 className={`${isLight ? "fw-special-title vector-heading-LIGHT" : "fw-special-title vector-heading"}`}>OUR SERVICES</h2>
                                                </div>
                                                <div className="vector-class-common">
                                                    <div className="dots-first">
                                                        <div className="dot-common"></div>
                                                        <div className="dot-common"></div>
                                                    </div>
                                                    <img className="vector-cross-common" src="/images/vector.png" alt="" />
                                                    <div className="dots-second">
                                                        <div className="dot-common"></div>
                                                        <div className="dot-common"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <img className="vector-line-common1" src="/images/Vector-upper-arrow.png" alt="" />
                                    </div>
                                    <div className="fw-row">
                                        <div className="fw-col-xs-12 ">
                                            <div className="fw-divider-space" style={{ marginTop: "20px" }}></div>
                                        </div>
                                    </div>
                                    <div className="fw-row">
                                        <div className="container">
                                            <div className="fw-col-xs-12 "></div>
                                            <div className="fw-col-xs-12 ">
                                                <p className={`${isLight ? "heading-common-main-LIGHT" : "heading-common-main"}`} style={{ textTransform: "uppercase" }}>{data?.serviceName}</p>
                                                <p className={`${isLight ? "heading-common-content-LIGHT" : "heading-common-content"}`}>
                                                    {data?.serviceDescription?.split(" ")?.slice(0, 10)?.join(" ") + "."}
                                                </p>
                                            </div>
                                            <div className="fw-col-xs-12 "></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <div className={`fw-main-row ${isLight ? "middle-content" : ""}`} style={{ backgroundColor: "#f1f1f1" }}>
                        <div className="fw-container">
                            <div className="fw-row">
                                <div className="fw-col-xs-12 ">
                                    <div className="fw-divider-space" style={{ marginTop: "60px" }}></div>
                                </div>
                            </div>

                            {data ? (
                                <div className="service_detail_content_order">
                                    <ServiceDetailCta />

                                    <div className="fw-row service_detail_section service_section_one">
                                        <div className="fw-col-xs-12 fw-col-sm-6 fw-col-md-6">
                                            <p className="exciting-ER4">{data?.sectionOne?.title}</p>
                                            <p className="portfolio-our-agencys">{data?.sectionOne?.sectionOneSubTitle}</p>
                                            <p className="portfolio-our-agency">{data?.sectionOne?.shortDescrition}</p>
                                        </div>
                                        <div className="fw-col-xs-12 fw-col-sm-6 fw-col-md-6">
                                            {data?.sectionOne?.image && <img src={data.sectionOne.image} alt={data?.sectionOne?.title || ""} />}
                                        </div>
                                    </div>

                                    <div className="service_detail_section">
                                        <div className="fw-row">
                                            <div className="fw-col-xs-12 fw-col-sm-6 fw-col-md-4 mb-3">
                                                <p className="exciting-ER4 m-0" style={{ lineHeight: "normal" }}>{data?.sectionTwo?.title}</p>
                                            </div>
                                            <div className="fw-col-xs-12 fw-col-sm-6 fw-col-md-8">
                                                <p className="portfolio-our-agencys" style={{ fontSize: "16px", lineHeight: "25px" }}>{data?.sectionTwo?.subTitle}</p>
                                                <p className="portfolio-our-agency" style={{ fontSize: "16px" }}>{data?.sectionTwo?.description}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <CustomSections sections={data?.customSections} />
                                    <AIAnswerBox box={data?.AIAnswerBox} />
                                    <QuickFacts facts={data?.quickFacts} />
                                    <ServiceHtmlSection section={data?.htmlSections?.whyThisServiceMatters} />
                                    <ServiceHtmlSection section={data?.htmlSections?.whatWeOffer} />
                                    <ServiceHtmlSection section={data?.htmlSections?.benefits} />
                                    <DevelopmentProcess process={data?.developmentProcess} />
                                    <ServiceHtmlSection section={data?.htmlSections?.technologies} />

                                    <div className="service_detail_section">
                                        <div>
                                            <p className="exciting-ER4 m-0 text-center" style={{ lineHeight: "normal" }}>{data?.sectionThird?.title}</p>
                                            {data?.sectionThird?.subTitle && <p className="portfolio-our-agencys text-center mt-3">{data.sectionThird.subTitle}</p>}
                                        </div>

                                        {industries?.length > 0 ? (
                                            <div className="service_industries desktop-layout">
                                                <div className="curve_box" />

                                                <div className="service_industries_content">
                                                    <div className="industry_row row_top">
                                                        {topRow.map((item, index) => (
                                                            <IndustryCard item={item} key={`top-${index}`} />
                                                        ))}
                                                    </div>

                                                    <div className="row_middle_wrapper">
                                                        {leftItem ? <IndustryCard item={leftItem} /> : <div className="industry_side_spacer" />}

                                                        <div className="row_middle_center">
                                                            {centerItems.map((item, index) => (
                                                                <IndustryCard item={item} key={`middle-${index}`} />
                                                            ))}
                                                        </div>

                                                        {rightItem ? <IndustryCard item={rightItem} /> : <div className="industry_side_spacer" />}
                                                    </div>

                                                    <div className="industry_row row_bottom">
                                                        {bottomRow.map((item, index) => (
                                                            <IndustryCard item={item} key={`bottom-${index}`} />
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <p className="text-center mt-4">No industries available</p>
                                        )}

                                        {industries?.length > 0 && (
                                            <div className="service_industries mobile-layout">
                                                <div className="row">
                                                    {industries.map((item, index) => (
                                                        <div className="col-sm-3 col-6 mb-3" key={index}>
                                                            <div className="service_industries_box side_box">
                                                                <img src={item.icon} alt="" />
                                                                <p>{item.serviceSectorName}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <ServiceHtmlSection section={data?.htmlSections?.whyChooseIshivax} />
                                    <CaseStudies caseStudies={data?.caseStudies} />
                                    <FactsFeatures section={data?.facts_features} />
                                </div>
                            ) : (
                                <p className="text-center">No service details available</p>
                            )}
                        </div>

                        <div className={`fw-main-row ${isLight ? "" : "black-bg-content"}`}>
                            <div className="fw-full-container-top">
                                <div className="content-under-image">
                                    <div className="fw-row ">
                                        <img className="vector-line-1 mt-4" src="/images/Vector-upper-arrow.png" alt="" />
                                    </div>
                                    <div className="fw-row">
                                        <div className="fw-container d-flex align-items-center">
                                            <div className="fw-col-md-4 vector-class">
                                                <div className="dot-1"></div>
                                                <div className="dot-2"></div>
                                                <img className="vector-cross-1" src="/images/vector.png" alt="" />
                                                <div className="dot-3"></div>
                                                <div className="dot-4"></div>
                                            </div>

                                            <div className="fw-col-md-4">
                                                <div className="fw-heading fw-heading-h2">
                                                    <h2 className={`fw-special-title  ${isLight ? "vector-heading-LIGHT" : "vector-heading"}`}>Get In Touch</h2>
                                                </div>
                                            </div>
                                            <div className="fw-col-md-4  vector-class">
                                                <div className="dot-5"></div>
                                                <div className="dot-6"></div>
                                                <img className="vector-cross-2" src="/images/vector.png" alt="" />
                                                <div className="dot-7"></div>
                                                <div className="dot-8"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="fw-row ">
                                        <img className="vector-line-2" src="/images/Vector-upper-arrow.png" alt="" />
                                    </div>
                                    <div className="fw-row">
                                        <div className="fw-col-xs-12 ">
                                            <div className="fw-divider-space" style={{ marginTop: "20px" }}></div>
                                        </div>
                                    </div>
                                    <div className="fw-row">
                                        <div className="container">
                                            <div className="fw-col-xs-12 "></div>
                                            <div className="fw-col-xs-12 ">
                                                <p className={`${isLight ? "services-for-more-info-LIGHT" : "services-for-more-info"}`}>For more information email us
                                                    at  <b>business@ishivax.com</b><br /> or call
                                                    at <b>+1-815 706 4781 / </b> <b>+91 9829-19-7777 </b>

                                                </p>
                                            </div>
                                            <div className="fw-col-xs-12" style={{ display: "flex", justifyContent: "center" }}>
                                                <Link to="/Quote">
                                                    <div className={`join-our-team-button ${isLight ? "frame-66-Y1q-LIGHT" : "frame-66-Y1q"}`}>
                                                        <div className="frame-66-Y1q-arrow get-quote-logo"></div>
                                                        <div className="frame-66-Y1q-text join-our-team-text">Get A
                                                            Quote
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                            <div className="fw-col-xs-12 ">
                                                <div className="fw-divider-space" style={{ marginTop: "80px" }}></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Faqs useCategoryApi categoryId={data?.serviceId} />
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    );
};

export default ServicesDetails;
